import { EntityStatus } from '../../../Entity'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import { getHasTableCellStatus } from './TableStatusCell.utils'

function TableStatusCell({ children, statuses, unread, value, ...cellProps }) {
  return getHasTableCellStatus({ statuses, value }) ? (
    <TableCellBase {...cellProps}>
      <EntityStatus id={value} statuses={statuses} />
      {children}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableStatusCell
